import { $, $$ } from './../helpers'

$$('.custom-file-control').forEach(el => {
    const control = $('[type="file"]', el)
    const value = $('.custom-file-control__value', el)

    control.addEventListener('change', () => value.textContent = control.value.split('\\').pop())
})
